import React from 'react';
import Button from './Button';
import styles from './ProfessorWelcome.module.css';

function DashboardSection({ completedSteps, onNavigateToDashboard }) {
  const isEnabled = completedSteps.size >= 2;

  return (
    <section className={`${styles.section} ${styles.sectionIncomplete}`} style={{ animationDelay: '0.2s' }}>
      <h2 className={styles.sectionTitle}>Manage Research Positions</h2>
      <p className={styles.sectionDescription}>
        Create and manage research opportunities for undergraduate and graduate students.
      </p>
      <Button
        onClick={() => isEnabled && onNavigateToDashboard()}
        disabled={!isEnabled}
      >
        Access Faculty Dashboard
      </Button>
    </section>
  );
}

export default DashboardSection;